<template>
  <div class="mainContainer container-fluid header">
    <div class="dataUser">
      <p>
        Welcome, <strong> {{ usuario ? usuario : "" }}</strong>
      </p>
      <p>
        Division: <strong>{{ division ? division : "" }}</strong>
      </p>
      <!--  <p v-if="nrocc">
        Credit Card: <strong>{{ nrocc }}</strong>
      </p>
      <p v-if="route">
        Route: <strong>{{ route }}</strong>
      </p> -->
    </div>
    <div class="menuItems">
      <!--  <div class="col-lg-12 border shadow"> -->
      <ul class="nav tabs mt-3 mb-3 nav-justified">
        <li class="nav-item" @click="displayMenu(0)">
          <b-icon icon="house-door-fill" aria-hidden="true"></b-icon>
          Home
        </li>
        <li class="nav-item" @click="displayMenu(1)">
          <b-icon icon="files" aria-hidden="true"></b-icon> Files
        </li>
        <li class="nav-item" @click="displayMenu(2)">
          <b-icon
            icon="pencil-square
"
            aria-hidden="true"
          ></b-icon>
          Transactions
        </li>
        <li class="nav-item" @click="displayMenu(3)">
          <b-icon icon="screwdriver" aria-hidden="true"></b-icon>
          Operations
        </li>
        <li class="nav-item" @click="displayMenu(4)">
          <b-icon icon="printer" aria-hidden="true"></b-icon> Reports
        </li>
      </ul>
      <hr />
      <div
        class="containerBoxMenu"
        v-for="item in menuSelected"
        :key="item.opt"
      >
        <div @click="goRoute(item.route)" class="boxMenu">
          <div class="iconMenu">
            <b-icon :icon="item.ico"></b-icon>
          </div>
          <div class="textMenu">{{ item.opt }}</div>
        </div>
      </div>
      <div v-if="showMarcadeAgua" class="marca-de-agua">
        <img alt="" src="@/assets/acu_logo.png" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuDesktop",
  data: function () {
    return {
      usuario: "",
      division: "",
      nrocc: "",
      route: "",
      menuActual: 0,
      showMarcadeAgua: false,
      menuSelected: [],
      menu: [
        [],
        [
          { opt: "Settings", ico: "gear" },
          { opt: "Users", ico: "person", route: "users" },
          { opt: "Divisions", ico: "building", route: "divisiones" },
          { opt: "Subdivisions", ico: "house", route: "subdivisiones" },
          { opt: "Routes", ico: "geo-alt", route: "routes" },
          { opt: "Credit Cards", ico: "credit-card", route: "creditcards" },
          { opt: "Employees", ico: "people", route: "employees" },
        ],
        [
          { opt: "Expenses", ico: "cash-stack" },
          { opt: "Landfills", ico: "truck", route: "landfills" },
        ],
        [
          { opt: "Invoice Verify", ico: "bookmark-check" },
          {
            opt: "Upload Data",
            ico: "box-arrow-in-up",
            route: "subdivisiones",
          },
        ],
        [
          { opt: "Divisions", ico: "building", route: "printdivisions" },
          { opt: "Subdivisions", ico: "house", route: "printsubdivisions" },
          { opt: "Routes", ico: "geo-alt", route: "printroutes" },
          { opt: "Credit Cards", ico: "credit-card" },
          { opt: "Employees", ico: "people", route: "printemployees" },
          { opt: "Landfills Companies", ico: "house", route: "printlandfills" },
          { opt: "Expenses", ico: "cash-stack" },
          { opt: "Landfills", ico: "truck" },
        ],
      ],
    };
  },
  mounted() {
    this.menuActual = localStorage.getItem("menuActual")
      ? localStorage.getItem("menuActual")
      : 0;
    this.usuario = localStorage.getItem("usuario");
    this.division = localStorage.getItem("division");
    this.nrocc = localStorage.getItem("nrocc");
    this.route = localStorage.getItem("route");
    console.log("MenuA: ", this.menuActual);
    this.displayMenu(this.menuActual);
  },
  /*  components: {
    Logo_ACU,
    Logo_IMA,
  }, */
  methods: {
    goRoute(route) {
      localStorage.setItem("menuActual", this.menuActual);
      this.$router.push(route);
    },
    displayMenu(idx) {
      localStorage.setItem("menuActual", idx);
      this.menuActual = idx;
      this.menuSelected = this.menu[idx];
      this.showMarcadeAgua = idx == 0 ? true : false;
    },
  },
};
</script>

<style scoped>
.dataUser {
  font-size: 14px;
  position: absolute;
  margin-top: -110px;
  margin-left: 750px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.dataUser p {
  line-height: 15px;
  justify-content: left;
  margin-bottom: 2px;
}

.mainContainer {
  background-color: #fff;
  max-width: 1000px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  max-height: 80vh;
}
.header {
  border: 1px solid #f2f2f2;
  margin-top: 0;
}

.marca-de-agua {
  /* background-image: url("@/assets/acu_logo.png"); */
  background-repeat: no-repeat;
  background-position: center;
  width: 50%;
  height: auto;
  margin: 130px auto;
}
.marca-de-agua img {
  padding: 0;
  width: 100%;
  height: auto;
  opacity: 0.04;
}

.menuItems {
  height: 700px;
  margin-left: 12px;
}

.nav-item {
  padding: 6px;
}

a {
  color: black;
  text-decoration: none;
}

li {
  background-color: #ebeee1;
  color: black;
  margin: 10px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  text-decoration: none;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
}
ul li a:active,
a:hover,
li:active,
li:hover {
  background-color: #b1d039;
  cursor: pointer;
  transition: 0.5s;
}
.containerBoxMenu {
  margin-top: 60px;
}
.boxMenu {
  float: left;
  margin-right: 40px;
  margin-bottom: 30px;
  width: 130px;
  height: 100px;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  color: #b1d039;
  font-size: 22px;
}
.boxMenu:hover {
  transform: scale(1.1);
  cursor: pointer;
}
.iconMenu {
  margin-top: 10px;
}
.textMenu {
  font-size: 1rem;
  color: rgb(10, 97, 7);
  margin: 10px 10px;
}
</style>
